import { useEffect, useMemo, useState } from 'react';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { toast } from 'react-toastify';

const Index = () => {

    const { readData: readDataBusiness } = useEntityCrud('Business/GetAllBusiness');
    const { readData: getBusinessPriceList } = useEntityCrud('PriceRequest/getPriceRequests');
    const { readData: getBusinessPhotoList } = useEntityCrud('PhotoRequest/getPhotoRequests');
    const { addData: changeBusinessPriceStatus } = useEntityCrud('PriceRequest/ConfirmPriceRequests');
    const { addData: changeBusinessPhotoStatus } = useEntityCrud('PhotoRequest/ConfirmPhotoRequests');

    const [businessList, setBusinessList] = useState([]);
    const [priceBusinessId, setPriceBusinessId] = useState(0);
    const [priceStatus, setPriceStatus] = useState(0);
    const [photoBusinessId, setPhotoBusinessId] = useState(0);
    const [photoStatus, setPhotoStatus] = useState(0);

    const [businessPrices,setBusinessPrices] = useState([]);
    const [businessPriceFetched,setBusinessPriceFetched] = useState(false);
    const [businessPhotos,setBusinessPhotos] = useState([]);
    const [businessPhotoFetched,setBusinessPhotoFetched] = useState(false);

    const businessAll = useMemo(() => businessList.map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));

    useEffect(() => {
        readDataBusiness().then(({ data }) => {
            if(data.status)
                setBusinessList(data.result);
        })
    },[])

    const filterPrices = () => {
        const postedData = {}
        if(priceBusinessId)
            postedData.businessId = priceBusinessId
        if(priceStatus != 0)
            postedData.isConfirmed = priceStatus == 1
        getBusinessPriceList(postedData).then(({ data }) => {
            if(data.status)
                setBusinessPrices(data.result)
            else
                setBusinessPrices([])
        }).finally(() => {
            setBusinessPriceFetched(true)
        })
    }

    const filterPhotos = () => {
        const postedData = {}
        if(photoBusinessId)
            postedData.businessId = photoBusinessId
        if(photoStatus != 0)
            postedData.isConfirmed = photoStatus == 1
        getBusinessPhotoList(postedData).then(({ data }) => {
            if(data.status)
                setBusinessPhotos(data.result)
            else
                setBusinessPhotos([])
        }).finally(() => {
            setBusinessPhotoFetched(true)
        })
    }

    useEffect(() => {
        filterPrices()
        filterPhotos()
    },[])

    const changePriceRowStatus = (id,isConfirmed) => {
        const postedData = {
            id,
            isConfirmed
        }
        changeBusinessPriceStatus(postedData).then(({ data }) => {
            if(data.status){
                toast.success('عملیات با موفقیت انجام شد');
                filterPrices()
            }else
                toast.error(data.message)
        })
    }

    const changePhotoRowStatus = (id,isConfirmed) => {
        const postedData = {
            id,
            isConfirmed
        }
        changeBusinessPhotoStatus(postedData).then(({ data }) => {
            if(data.status){
                toast.success('عملیات با موفقیت انجام شد');
                filterPhotos()
            }else
                toast.error(data.message)
        })
    }

    return (
        <>
            <ul className="nav nav-pills mb-3 mt-4" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation">
                    <button className="nav-link active py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#prices" type="button" role="tab" aria-selected="true">قیمت های در انتظار تایید</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link py-3 mb-1 px-5" data-bs-toggle="pill" data-bs-target="#images" type="button" role="tab" aria-selected="true">تصاویر در انتظار تایید</button>
                </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="prices" role="tabpanel" aria-labelledby="prices-tab" tabindex="0">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title" >لیست قیمت های در انتظار تایید</div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>کسب و کار</label>
                                        {!!priceBusinessId && <i className="fe fe-x clear-select-btn" onClick={() => setPriceBusinessId('')}></i>}
                                        <ReactSelect label="کسب و کار"
                                            options={businessAll.filter(item => item.isActive === true)}
                                            value={businessAll.find(item => item.id == priceBusinessId)}
                                            onChange={e => setPriceBusinessId(e.value)}
                                            placeholder="انتخاب کنید"
                                            name="buisnessId"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>وضعیت</label>
                                        <select className="form-control" onChange={e => setPriceStatus(e.target.value)}>
                                            <option selected value={0}>همه</option>
                                            <option value="1">تایید شده</option>
                                            <option value="2">رد شده</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <button className="btn btn-success" style={{marginTop: 29}} onClick={filterPrices}>جستجو</button>
                                </div>
                            </div>
                            {businessPrices.length > 0 && <hr className="mb-4" />}
                            {businessPrices.length > 0 ? <div className="table-responsive">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>شناسه</th>
                                            <th>کسب و کار</th>
                                            <th>عنوان محصول / خدمت</th>
                                            <th>قیمت</th>
                                            <th>وضعیت</th>
                                            <th>عملیات</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {businessPrices.map((price,index) => <tr key={`price-${index}`}>
                                            <td>{price.id}</td>
                                            <td>{price.businessTitle}</td>
                                            <td>{price.subServiceTitle}</td>
                                            <td>{new Intl.NumberFormat('en-IR', { maximumSignificantDigits: 20 }).format(price.price)}</td>
                                            <td>{price.isConfirmed ? 'تایید شده' : (price.isConfirmed === false ? 'رد شده' : 'در انتظار بررسی')}</td>
                                            {price.isConfirmed == null ? <td className="btn-list">
                                                <button className="btn btn-success btn-icon" onClick={() => changePriceRowStatus(price.id,true)}><i className="fe fe-check"></i></button>
                                                <button className="btn btn-danger btn-icon" onClick={() => changePriceRowStatus(price.id,false)}><i className="fe fe-x"></i></button>
                                            </td> : <td>-</td>}
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div> : (businessPriceFetched ? <div className="alert alert-info mt-4 mb-0">
                                <p className="mb-0">داده ای یافت نشد</p>
                            </div> : '')}
                        </div>
                    </div>
                </div>
                <div className="tab-pane fade" id="images" role="tabpanel" aria-labelledby="images-tab" tabindex="0">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-title" >لیست تصاویر در انتظار تایید</div>
                        </div>
                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">
                                    <div className="form-group">
                                        <label>کسب و کار</label>
                                        {!!photoBusinessId && <i className="fe fe-x clear-select-btn" onClick={() => setPhotoBusinessId('')}></i>}
                                        <ReactSelect label="کسب و کار"
                                            options={businessAll.filter(item => item.isActive === true)}
                                            value={businessAll.find(item => item.id == photoBusinessId)}
                                            onChange={e => setPhotoBusinessId(e.value)}
                                            placeholder="انتخاب کنید"
                                            name="buisnessId"
                                        />
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <div className="form-group">
                                        <label>وضعیت</label>
                                        <select className="form-control" onChange={e => setPhotoStatus(e.target.value)}>
                                            <option selected value={0}>همه</option>
                                            <option value="1">تایید شده</option>
                                            <option value="2">رد شده</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <button className="btn btn-success" style={{marginTop: 29}} onClick={filterPhotos}>جستجو</button>
                                </div>
                            </div>
                            {businessPhotos.length > 0 && <hr className="mb-4" />}
                            {businessPhotos.length > 0 ? <div className="table-responsive">
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>شناسه</th>
                                            <th>کسب و کار</th>
                                            <th>تصویر</th>
                                            <th>وضعیت</th>
                                            <th>عملیات</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {businessPhotos.map((photo,index) => <tr key={`photo-${index}`}>
                                            <td>{photo.id}</td>
                                            <td>{photo.businessTitle}</td>
                                            <td><a href={!photo.photoContent.includes('ExcelPath') ? `https://petromah.sabinarya.com/ExcelPath/${photo.photoContent}` : `https://petromah.sabinarya.com${photo.photoContent}`} target="_blank">کلیک کنید</a></td>
                                            <td>{photo.isConfirmed ? 'تایید شده' : (photo.isConfirmed === false ? 'رد شده' : 'در انتظار بررسی')}</td>
                                            {photo.isConfirmed == null ? <td className="btn-list">
                                                <button className="btn btn-success btn-icon" onClick={() => changePhotoRowStatus(photo.id,true)}><i className="fe fe-check"></i></button>
                                                <button className="btn btn-danger btn-icon" onClick={() => changePhotoRowStatus(photo.id,false)}><i className="fe fe-x"></i></button>
                                            </td> : <td>-</td>}
                                        </tr>)}
                                    </tbody>
                                </table>
                            </div> : (businessPhotoFetched ? <div className="alert alert-info mt-4 mb-0">
                                <p className="mb-0">داده ای یافت نشد</p>
                            </div> : '')}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Index